module.exports = __webpack_public_path__ + "media/images/background-top-pdf-79a473297aafa96a325cbf79c625ba53.png";